<ng-container>
    <router-outlet />
    <app-logo-overlay-loader *ngIf="loader.loading()"/>
</ng-container>